<template>
  <div>

    <section class="hero is-small is-dark is-bold">
      <div class="hero-body">
        <div class="container container-login">
          <img src="../assets/logoKDCA-white.svg" width="250px">
          <!--<h1 class="title">-->
          <!--K.R.C.A.-->
          <!--</h1>-->
          <!--<h3 class="subtitle">-->
          <!--CBC - Keyword Recognition for Conversational Agents-->
          <!--</h3>-->
        </div>
      </div>
    </section>

    <div class="container container-login">

      <div class="field">
        <p class="control has-icons-left">
          <input class="input" placeholder="Email" type="email" v-model="user.user">
          <span class="icon is-small is-left"><i class="fas fa-user"></i></span>
        </p>
      </div>

      <div class="field">
        <p class="control has-icons-left">
          <input class="input" placeholder="Password" type="password" v-model="user.password">
          <span class="icon is-small is-left"><i class="fas fa-lock"></i></span>
        </p>
      </div>

      <br>

      <div class="control">
        <button class="button is-primary" @click="login">Acceder</button>
      </div>
    </div>
  </div>
</template>

<script>
import Auth from '../models/auth'
import Crisp from '../models/crisp'

export default {
  data() {
    return {
      user: {
        user: null,
        password: null
      }
    }
  },
  created() {
    this.user = {
      user: '',
      password: ''
    }

    Crisp.hide()
  },
  methods: {
    login() {
      this.api.post('/UserBackLogin', this.user).then(response => {
        Auth.setAuthorization(response.user)
        this.$router.push('/clients')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue